import { toNumber } from '~/utils/utils';
import { setLoginType } from '@/common/common.js';
import { getStorageSync } from '@/utils/storage.js';

/**
 * 根据当前路由解析业务站点 companyId。
 * 解析优先级：
 * 1) query.companyId：列表/搜索类页面最常见
 * 2) params.companyId：动态路由（如 /[companyId]/home）
 * 3) path 正则兜底：兼容字符串路由拼接场景
 * 4) 默认返回 1（主站）
 */
export function resolveCompanyId(route: any): number {
	const fromQuery = toNumber(route?.query?.companyId);
	if (fromQuery) return fromQuery;

	const fromParams = toNumber(route?.params?.companyId);
	if (fromParams) return fromParams;

	const path = String(route?.path || '');
	const childSiteMatch = path.match(/^\/(\d+)(?:\/|$)/i);
	if (childSiteMatch?.[1]) return Number(childSiteMatch[1]);
	// 兼容旧商详：/goodDetail/{productId}/{companyId}（新路由 /{companyId}/products/{productId}.html 已由首段数字解析）
	const goodDetailMatch = path.match(/\/goodDetail\/[^/]+\/(\d+)/i);
	if (goodDetailMatch?.[1]) return Number(goodDetailMatch[1]);

	return 1;
}

export default defineNuxtPlugin(nuxtApp => {
	if (!import.meta.client) return;

	let lastCompanyId: number | null = null;

	const syncLoginType = async (route: any) => {
		const token = getStorageSync('cmdc_access_token_mobile');
		if (!token) {
			lastCompanyId = null;
			return;
		}

		const companyId = resolveCompanyId(route);
		const cached = getStorageSync('loginType');
		if (companyId === lastCompanyId && cached) return;
		lastCompanyId = companyId;

		try {
			await setLoginType(companyId);
		} catch (e) {
			console.error('[loginType] sync failed:', e);
		}
	};

	const router = nuxtApp.$router as
		| {
				currentRoute?: { value?: any };
				afterEach?: (guard: (to: any) => void) => void;
		  }
		| undefined;
	if (!router?.currentRoute?.value) return;

	syncLoginType(router.currentRoute.value);
	router.afterEach?.(to => {
		syncLoginType(to);
	});
});
